import InviteEnrolleePage from './invite-enrollee-page'

export default InviteEnrolleePage
